export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos de registro"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar datos"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Confirmado"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Este campo es público y visible para otros usuarios"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Este campo está oculto para otros usuarios"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificación de identidad"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificado"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En progreso"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No verificado"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iniciar verificación"])}
}